import { createSelector } from 'reselect';
import { preAssessmentDetails } from '@/selectors/merchant';

export const getDefaultState = createSelector(
  preAssessmentDetails,
  ({ sellingCountries = { all: [] } }) => ({ sellingCountries: sellingCountries.all }),
);
